import apiService from './apiService';

class PortService {
  async getPorts(skip = 0, limit = 10) {
    try {
      const endpoint = `/api/v1/ports/ports/?skip=${skip}&limit=${limit}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch ports:', error);
      throw error;
    }
  }

  async getAllPorts() {
    try {
      const endpoint = `/api/v1/ports/ports/`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch all ports:', error);
      throw error;
    }
  }

  async getPortById(id) {
    try {
      const endpoint = `/api/v1/ports/ports/${id}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to fetch port with ID ${id}:`, error);
      throw error;
    }
  }

  async createPort(portData) {
    try {
      const endpoint = '/api/v1/ports/ports/';
      const response = await apiService.post(endpoint, portData);
      return response;
    } catch (error) {
      console.error('Failed to create port:', error);
      if (error.message && error.message.includes('already exists')) {
        throw new Error('A port with this code already exists. Please use a different port code.');
      }
      throw error;
    }
  }

  async updatePort(id, portData) {
    try {
      const endpoint = `/api/v1/ports/ports/${id}`;
      const response = await apiService.put(endpoint, portData);
      return response;
    } catch (error) {
      console.error(`Failed to update port with ID ${id}:`, error);
      if (error.message && error.message.includes('already exists')) {
        throw new Error('A port with this code already exists. Please use a different port code.');
      }
      throw error;
    }
  }

  async deletePort(id) {
    try {
      const endpoint = `/api/v1/ports/ports/${id}`;
      const response = await apiService.delete(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to delete port with ID ${id}:`, error);
      throw error;
    }
  }

  async uploadPortImage(entityId, file, fileType, description = '') {
    try {
      if (!file || !(file instanceof File)) {
        throw new Error('Invalid file object provided for upload');
      }
      
      const endpoint = `/api/v1/enhanced-files/upload/port/${entityId}`;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('file_type', 'port_photo');
      formData.append('description', description || `Port photo for port ${entityId}`);
      
      const response = await apiService.uploadFile(endpoint, formData);
      return response;
    } catch (error) {
      console.error(`Failed to upload image for port ${entityId}:`, error);
      if (error.message) {
        throw new Error(`File upload failed: ${error.message}`);
      } else {
        throw new Error('File upload failed due to an unknown error. Please check the console for more details.');
      }
    }
  }
}

export default new PortService();